var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"refresh-button"},[(_vm.lastRequest)?_c('div',{staticClass:"last-request hidden-sm-and-down"},[_vm._v("\n      Last refreshed "+_vm._s(_vm.timeSinceLoad)+"\n    ")]):_vm._e(),_c('el-button',{staticClass:"secondary",attrs:{"round":""},on:{"click":_vm.refresh}},[_c('i',{staticClass:"el-icon-refresh"})])],1),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e44dfa0a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fitness/FitnessContainer.vue
// module id = null
// module chunks = 